import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { userCanAccessNav } from "../navigation/navigation";

// Guard de rota por FUNCIONALIDADE (não por nome de papel): quem não tem a funcionalidade da área
// que tenta abrir por URL é reencaminhado para a aterragem (a primeira área a que tem acesso). É a
// mesma decisão do menu (userCanAccessNav), para não haver duas verdades. O backend continua a ser
// a autoridade — nega os dados na mesma; isto só evita ecrãs vazios e URLs que "não fazem nada".
export function RequireBackOffice() {
  const { user } = useAuth();
  const location = useLocation();
  const isAdmin = user?.roles?.includes("Administrator") ?? false;

  // O primeiro segmento do caminho é o id da área (ex.: /faturas/editar/7 → "faturas").
  const segment = location.pathname.split("/").filter(Boolean)[0] ?? "";

  if (userCanAccessNav(isAdmin, user?.features, segment)) {
    return <Outlet />;
  }

  return <Navigate to="/" replace />;
}
